<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.M" label="M"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.Hd" label="Hd"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.Td" label="Td"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.D" label="D"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.H" label="H"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 337 97.25"
         style="height: 150px"
    >
        <defs>
            <style>.mhdtddhte1{fill:#eaf4fb;}.mhdtddhte2{fill:#1d1d1b;}.mhdtddhte3,.mhdtddhte4,.mhdtddhte5{fill:none;stroke:#0090c9;}.mhdtddhte3{stroke-width:1.5px;}.mhdtddhte4{stroke-width:3px;}.mhdtddhte5{stroke-width:1.5px;}.mhdtddhte6{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_MHdTdDHTE_schema</title>
        <rect class="mhdtddhte1"
              x="1"
              y="1.25"
              width="336"
              height="48" />
        <path class="mhdtddhte2"
              d="M160.77,15.91h5.85c2.71,0,5.91,0,8.15,2.64a11.63,11.63,0,0,1,2.49,7.64c0,4.37-1.82,7.06-3.36,8.29-2,1.65-4.48,1.65-7.45,1.65h-5.68Zm2.8,17.92h2.74c1.93,0,3.95-.11,5.29-1.12,2.58-1.93,2.66-5.23,2.66-6.41,0-.75,0-4.2-2-6.3-1.29-1.43-2.91-1.76-5.37-1.76h-3.36Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M263,36.13V18.29h-6.78V15.91h16.32v2.38h-6.77V36.13Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M305.89,15.91h12.68v2.38h-9.88v6.3h9.41V27h-9.41v6.72H318.8v2.46H305.89Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M110,36.13V18.29h-6.78V15.91H119.5v2.38h-6.78V36.13Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M132.15,15.94h2.63v18c0,.31.06,1.51.12,2.24h-2.64l0-2.24A4.13,4.13,0,0,1,131,35.37a6.35,6.35,0,0,1-3.48,1c-1.87,0-6-1-6-7.14,0-5.35,3-7.67,6.35-7.67A4.53,4.53,0,0,1,132.15,24Zm-1,9a3.81,3.81,0,0,0-3.08-1.43c-3.86,0-3.86,4.67-3.86,5.63,0,2.49.64,5.37,3.86,5.37,4.14,0,4.14-4.56,4.14-5.65A6,6,0,0,0,131.17,25Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M210.72,15.91v8.68h9.6V15.91h2.8V36.13h-2.8V27h-9.6v9.13h-2.8V15.91Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M57.36,15.91v8.68H67V15.91h2.8V36.13H67V27H57.36v9.13h-2.8V15.91Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M84.8,15.94h2.63v18c0,.31.06,1.51.12,2.24H84.91l0-2.24a4,4,0,0,1-1.26,1.48,6.34,6.34,0,0,1-3.47,1c-1.88,0-6-1-6-7.14,0-5.35,3-7.67,6.35-7.67A4.52,4.52,0,0,1,84.8,24Zm-1,9a3.8,3.8,0,0,0-3.08-1.43c-3.86,0-3.86,4.67-3.86,5.63,0,2.49.64,5.37,3.86,5.37,4.15,0,4.15-4.56,4.15-5.65A6,6,0,0,0,83.82,25Z"
              transform="translate(1 -0.75)" />
        <path class="mhdtddhte2"
              d="M12.2,15.91h4.95l5.72,16.66,5.85-16.66h4.62V36.13H30.59V17.93L24,36.13H21.3L14.91,18V36.13H12.2Z"
              transform="translate(1 -0.75)" />
        <line class="mhdtddhte3"
              x1="96.58"
              y1="1.25"
              x2="96.58"
              y2="97.25" />
        <line class="mhdtddhte3"
              x1="144.75"
              y1="1.25"
              x2="144.75"
              y2="97.25" />
        <line class="mhdtddhte3"
              x1="240.49"
              y1="1.25"
              x2="240.49"
              y2="97.25" />
        <line class="mhdtddhte3"
              x1="288.66"
              y1="1.25"
              x2="288.66"
              y2="97.25" />
        <line class="mhdtddhte4"
              x1="192.75"
              y1="1.25"
              x2="192.75"
              y2="97.25" />
        <line class="mhdtddhte4"
              x1="48"
              y1="1.25"
              x2="48"
              y2="97.25" />
        <line class="mhdtddhte5"
              x1="1"
              y1="49.75"
              x2="337"
              y2="49.75" />
        <line class="mhdtddhte3"
              x1="1"
              y1="0.75"
              x2="337"
              y2="0.75" />
        <text class="mhdtddhte6"
              transform="translate(305.22 84.77)">{{rangeModel.E}}</text>
        <text class="mhdtddhte6"
              transform="translate(256.22 84.77)">{{rangeModel.T}}</text>
        <text class="mhdtddhte6"
              transform="translate(209.22 84.77)">{{rangeModel.H}}</text>
        <text class="mhdtddhte6"
              transform="translate(160.22 84.77)">{{rangeModel.D}}</text>
        <text class="mhdtddhte6"
              transform="translate(112.22 84.77)">{{rangeModel.Td}}</text>
        <text class="mhdtddhte6"
              transform="translate(64.22 84.77)">{{rangeModel.Hd}}</text>
        <text class="mhdtddhte6"
              transform="translate(16.22 84.77)">{{rangeModel.M}}</text>
    </svg>
</ng-template>

